module.exports = __webpack_public_path__ + "img/wedcr8.5bfca947.jpg";